import React, { useState, useEffect } from 'react';
import ProductCard from '../components/ProductCard';
import { useLanguage } from '../context/LanguageContext';
import './Home.css';

const Home = () => {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [storeOpen, setStoreOpen] = useState(null);
  const { language, isRTL } = useLanguage();

  useEffect(() => {
    fetchStoreStatus();
    fetchProducts();
  }, []);

  const fetchStoreStatus = async () => {
    try {
      const response = await fetch('/api/settings/public');
      if (response.ok) {
        const settings = await response.json();
        setStoreOpen(settings.storeOpen);
      }
    } catch (error) {
      console.error('Failed to fetch store status:', error);
      setStoreOpen(false);
    }
  };

  const fetchProducts = async () => {
    try {
      const response = await fetch('/api/products');
      const data = await response.json();
      setProducts(data);
    } catch (error) {
      console.error('Failed to fetch products:', error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className={`home ${isRTL ? 'rtl' : 'ltr'}`} dir={isRTL ? 'rtl' : 'ltr'}>
      <section className="products-section">
        <div className="container">
          {storeOpen === null || loading ? (
            <div className="loading">
              <div className="spinner"></div>
            </div>
          ) : !storeOpen ? (
            <div style={{ textAlign: 'center', padding: '80px 20px' }}>
              <div style={{ marginBottom: '16px' }}><svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="#9ca3af" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg></div>
              <h2 style={{ fontSize: '22px', fontWeight: '700', color: '#1e293b', marginBottom: '8px' }}>
                {language === 'ar' ? 'المتجر مغلق حالياً' : 'Store is currently closed'}
              </h2>
              <p style={{ color: '#6b7280', fontSize: '15px', maxWidth: '400px', margin: '0 auto' }}>
                {language === 'ar'
                  ? 'لا توجد منتجات متاحة حالياً. يرجى العودة لاحقاً.'
                  : 'No items are available at the moment. Please check back later.'}
              </p>
            </div>
          ) : (
            <div className="products-grid">
              {products.map(product => (
                <ProductCard key={product.id} product={product} />
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default Home;
